export enum OtpType {
    PHONE = 'phone',
    GOOGLE_AUTH = 'googleAuth',
}
